<div class="offtime-page figma-offtime">


  <header class="offtime-page-header">
  <div>
    <p class="eyebrow">Off Time Management</p>
    <h1>{{ activeTab === 'Create' ? 'Book Off Time' : getActiveTabTitle() }}</h1>
  </div>
</header>

<nav class="offtime-tabs" aria-label="Off Time sections">
  <button type="button" class="offtime-tab" [class.active]="activeTab === 'Create'" (click)="setTab('Create')">
    Book Off Time
  </button>

  <button type="button" class="offtime-tab" [class.active]="activeTab === 'Approved'" (click)="setTab('Approved')">
    Approved
    <span class="tab-count approved">{{ getTabCount('Approved') }}</span>
  </button>

  <button type="button" class="offtime-tab" [class.active]="activeTab === 'Pending'" (click)="setTab('Pending')">
    Pending
    <span class="tab-count pending">{{ getTabCount('Pending') }}</span>
  </button>

  <button type="button" class="offtime-tab" [class.active]="activeTab === 'Rejected'" (click)="setTab('Rejected')">
    Rejected
    <span class="tab-count rejected">{{ getTabCount('Rejected') }}</span>
  </button>

  <button type="button" class="offtime-tab" [class.active]="activeTab === 'Cancelled'" (click)="setTab('Cancelled')">
    Cancelled
    <span class="tab-count cancelled">{{ getTabCount('Cancelled') }}</span>
  </button>
</nav>

  <div *ngIf="isBusy" class="busy-overlay" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
  </div>

  <main *ngIf="activeTab === 'Create'" class="offtime-main">
    <div class="figma-title-block">
      <h1>Book Off Time</h1>
      <p>Fields marked <span class="required">*</span> are required.</p>
    </div>

    <section class="figma-booking-layout">
      <div class="figma-calendar-card">
        <div class="figma-month-header">
          <span class="figma-month-title">{{ calendarMonth.format('MMMM YYYY') }}</span>

          <div class="figma-calendar-nav">
            <button type="button" class="figma-nav-btn" (click)="prevMonth()" aria-label="Previous month">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>

            <button type="button" class="figma-nav-btn" (click)="nextMonth()" aria-label="Next month">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>

        <div class="figma-calendar-body">
          <div class="figma-dow-row">
            <div class="figma-dow">Su</div>
            <div class="figma-dow">Mo</div>
            <div class="figma-dow">Tu</div>
            <div class="figma-dow">We</div>
            <div class="figma-dow">Th</div>
            <div class="figma-dow">Fr</div>
            <div class="figma-dow">Sa</div>
          </div>

          <div class="figma-day-grid">
            <button
              type="button"
              class="figma-day-cell"
              *ngFor="let cell of (calendarCells || [])"
              [class.empty]="!cell"
              [class.selected]="cell && isSelectedDay(cell)"
              [class.disabled]="cell && !isDateSelectable(cell)"
              [disabled]="!cell || (cell && !isDateSelectable(cell))"
              (click)="cell && toggleDaySelection(cell)"
            >
              <ng-container *ngIf="cell; else emptyCell">{{ cell.date() }}</ng-container>
              <ng-template #emptyCell>&nbsp;</ng-template>
            </button>
          </div>
        </div>

        <div class="figma-calendar-footer">
          <div class="figma-calendar-info" *ngIf="selectedDays.length; else selectDateHint">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 16v-4" />
              <path d="M12 8h.01" />
            </svg>

            <span><strong>{{ selectedDays.length }}</strong> day{{ selectedDays.length === 1 ? '' : 's' }} selected</span>
          </div>

          <ng-template #selectDateHint>
            <div class="figma-calendar-info">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>
              <span>Click dates to select</span>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="figma-form-card">
        <div class="figma-form-sections">
          <div class="figma-split-row">
            <div class="figma-field-cell">
              <label>Employee <span class="required">*</span></label>

              <select *ngIf="isAdmin" [(ngModel)]="createEmployeeId">
                <option [ngValue]="null">Self (current user)</option>
                <option *ngFor="let u of users" [ngValue]="u.id">
                  {{ u.firstName }} {{ u.lastName }}
                  <ng-container *ngIf="u.employeeNumber"> (#{{ u.employeeNumber }})</ng-container>
                </option>
              </select>

              <select *ngIf="!isAdmin" [(ngModel)]="createEmployeeId">
                <option [ngValue]="currentUserDetail?.id">
                  {{ currentUserDetail?.firstName }} {{ currentUserDetail?.lastName }}
                </option>
              </select>
            </div>

            <div class="figma-field-cell">
              <label>Pay Code <span class="required">*</span></label>

              <select [(ngModel)]="selectedPayCodeId">
                <option [ngValue]="null">Select pay code…</option>
                <option *ngFor="let pc of payCodes" [ngValue]="pc.id">{{ pc.name }}</option>
              </select>
            </div>
          </div>

          <div
            class="figma-balance-bar"
            *ngIf="createBalanceImpact"
            [class.over-limit]="!createBalanceImpact.allowNegativeBalance && (createBalanceImpact.currentBalance - createBalanceImpact.requestedHours) < 0"
          >
            <div class="figma-balance-left">
              <span class="figma-balance-label">{{ createBalanceImpact.leaveType }} Balance</span>
              <strong>{{ createBalanceImpact.currentBalance | number:'1.0-1' }}h available</strong>

              <span *ngIf="createBalanceImpact.requestedHours > 0" class="figma-balance-divider">—</span>
              <span *ngIf="createBalanceImpact.requestedHours > 0">{{ createBalanceImpact.requestedHours | number:'1.0-1' }}h requested</span>

              <span *ngIf="createBalanceImpact.requestedHours > 0" class="figma-balance-divider">—</span>
              <strong
                *ngIf="createBalanceImpact.requestedHours > 0"
                class="figma-remaining"
                [class.negative]="(createBalanceImpact.currentBalance - createBalanceImpact.requestedHours) < 0"
              >
                {{ (createBalanceImpact.currentBalance - createBalanceImpact.requestedHours) | number:'1.0-1' }}h remaining
              </strong>
            </div>

            <div
              class="figma-balance-error"
              *ngIf="!createBalanceImpact.allowNegativeBalance && (createBalanceImpact.currentBalance - createBalanceImpact.requestedHours) < 0"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8v5" />
                <path d="M12 16h.01" />
              </svg>
              Exceeds balance
            </div>
          </div>

          <div class="figma-schedule-section" *ngIf="selectedDays.length">
            <div class="figma-schedule-head">
              <label>Schedule <span class="required">*</span></label>

              <div class="figma-bulk-apply">
                <span>Apply all:</span>

                <select [ngModel]="defaultStartMinutes" (ngModelChange)="onDefaultStartMinutesChange($event)">
                  <option *ngFor="let t of timeOptions" [ngValue]="t.minutes">{{ t.label }}</option>
                </select>

                <span>–</span>

                <select [ngModel]="defaultEndMinutes" (ngModelChange)="onDefaultEndMinutesChange($event)">
                  <option *ngFor="let t of getEndTimeOptionsAfter(defaultStartMinutes)" [ngValue]="t.minutes">
                    {{ t.label }}
                  </option>
                </select>

                <button type="button" (click)="applyDefaultTimesToAllSelectedDays()">Apply</button>
              </div>
            </div>

            <div class="figma-schedule-list">
              <div class="figma-schedule-row" *ngFor="let day of selectedDays; let i = index">
                <div class="figma-schedule-date">
                  <span class="figma-schedule-index">{{ i + 1 }}</span>
                  <span>{{ day.date.format('ddd, MMM D') }}</span>
                </div>

                <div class="figma-schedule-times">
                  <select [ngModel]="day.startMinutes" (ngModelChange)="onSelectedDayStartMinutesChange(day, $event)">
                    <option *ngFor="let t of timeOptions" [ngValue]="t.minutes">{{ t.label }}</option>
                  </select>

                  <span class="figma-time-dash">–</span>

                  <select [ngModel]="day.endMinutes" (ngModelChange)="onSelectedDayEndMinutesChange(day, $event)">
                    <option *ngFor="let t of getEndTimeOptionsAfter(day.startMinutes)" [ngValue]="t.minutes">
                      {{ t.label }}
                    </option>
                  </select>

                  <span class="figma-duration-pill">{{ ((day.endMinutes - day.startMinutes) / 60) | number:'1.0-2' }}h</span>
                </div>
              </div>
            </div>
          </div>

          <div class="figma-field-cell full">
            <label>Reason <span class="required">*</span></label>
            <textarea rows="3" [(ngModel)]="createReason" placeholder="Briefly describe the reason for this off-time request…"></textarea>
          </div>

          <div class="figma-field-cell full">
            <label>Attachment <span class="optional">(optional)</span></label>

            <label class="figma-attachment-dropzone" [class.has-files]="selectedCreateFiles.length">
              <input type="file" multiple (change)="onCreateFilesSelected($event)" />

              <ng-container *ngIf="selectedCreateFiles.length; else emptyUpload">
                <span class="figma-attachment-icon primary">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <path d="M14 2v6h6" />
                    <path d="M16 13H8" />
                    <path d="M16 17H8" />
                    <path d="M10 9H8" />
                  </svg>
                </span>

                <span class="figma-attachment-copy">
                  <strong>{{ selectedCreateFiles.length }} file{{ selectedCreateFiles.length === 1 ? '' : 's' }} selected</strong>
                  <small>{{ selectedCreateFiles[0].name }}</small>
                </span>
              </ng-container>

              <ng-template #emptyUpload>
                <span class="figma-attachment-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <path d="m17 8-5-5-5 5" />
                    <path d="M12 3v12" />
                  </svg>
                </span>

                <span class="figma-attachment-copy">
                  <strong>Drop a file or click to upload</strong>
                  <small>PDF, JPG, PNG, DOC — up to 10 MB</small>
                </span>
              </ng-template>
            </label>

            <div class="figma-selected-files" *ngIf="selectedCreateFiles.length">
              <span class="figma-selected-file" *ngFor="let file of selectedCreateFiles; let i = index">
                {{ file.name }}
                <button type="button" (click)="removeCreateFile(i)" [disabled]="isBusy">×</button>
              </span>
            </div>
          </div>

          <div class="figma-actions-row">
            <button type="button" class="figma-clear-btn" (click)="resetCreate()" [disabled]="isBusy">Clear</button>

            <div class="figma-submit-actions">
              <span
                class="figma-insufficient"
                *ngIf="createBalanceImpact && !createBalanceImpact.allowNegativeBalance && (createBalanceImpact.currentBalance - createBalanceImpact.requestedHours) < 0"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v5" />
                  <path d="M12 16h.01" />
                </svg>
                Insufficient hours
              </span>

              <button
                type="button"
                class="figma-submit-btn"
                (click)="submitCreate()"
                [disabled]="isBusy || !selectedDays.length || !selectedPayCodeId || !canSubmitForBalance"
              >
                Review & Submit →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>

  <main *ngIf="activeTab !== 'Create' && viewMode === 'list'" class="figma-requests-page">
    <section class="figma-page-title">
      <h1>
        {{ getActiveTabTitle() }}
        <span
          class="heading-count"
          [class.approved]="activeTab === 'Approved'"
          [class.pending]="activeTab === 'Pending'"
          [class.rejected]="activeTab === 'Rejected'"
          [class.cancelled]="activeTab === 'Cancelled'"
        >
          {{ getActiveTabCount() }}
        </span>
      </h1>

      <p>{{ getActiveTabSubtitle() }}</p>
    </section>

    <section class="figma-filter-bar">
      <div class="figma-filter-left">
       <button
  type="button"
  class="figma-filter-button"
  [class.primary]="offtimeOrderBy === 'startDateDesc' || offtimeOrderBy === 'startDateAsc'"
  (click)="onOfftimeOrderByChange(offtimeOrderBy === 'startDateDesc' ? 'startDateAsc' : 'startDateDesc')"
>
  Start Date
  <span>{{ offtimeOrderBy === 'startDateAsc' ? '↑' : '↓' }}</span>
</button>

<button
  type="button"
  class="figma-filter-button"
  [class.primary]="offtimeOrderBy === 'approvedAtDesc' || offtimeOrderBy === 'approvedAtAsc'"
  (click)="onOfftimeOrderByChange(offtimeOrderBy === 'approvedAtDesc' ? 'approvedAtAsc' : 'approvedAtDesc')"
>
  Approved Date
  <span>{{ offtimeOrderBy === 'approvedAtAsc' ? '↑' : '↓' }}</span>
</button>

        <span class="figma-filter-divider"></span>

        <span class="figma-date-label">Date range:</span>

        <input type="date" [(ngModel)]="offtimeStartDate" (ngModelChange)="onOfftimeDateRangeChange()" />
        <span class="figma-date-to">to</span>
        <input type="date" [(ngModel)]="offtimeEndDate" (ngModelChange)="onOfftimeDateRangeChange()" />
      </div>

      <span class="figma-result-count">{{ getActiveTabCount() }} total results</span>
    </section>

    <section class="figma-request-section">
     <div class="figma-section-header">
    <div class="figma-section-label">
      <span>MY REQUESTS</span>
      <span class="section-count">{{ getRequestTotalForActiveTab('mine') }}</span>
    </div>

    <div class="figma-section-pager" *ngIf="getRequestPageInfoForActiveTab('mine') as page">
      <button
        type="button"
        (click)="goToRequestPage(activeTab, 'mine', page.currentPage - 1)"
        [disabled]="isBusy || page.currentPage <= 1">
        ←
      </button>

      <span>{{ page.currentPage }} / {{ page.totalPages }}</span>

      <button
        type="button"
        (click)="goToRequestPage(activeTab, 'mine', page.currentPage + 1)"
        [disabled]="isBusy || page.currentPage >= page.totalPages">
        →
      </button>
    </div>
  </div>

      <div class="figma-request-grid my-grid" *ngIf="getMyRequestsForActiveTab().length; else noMyRequests">
        <button
          type="button"
          class="figma-status-card"
          *ngFor="let item of getMyRequestsForActiveTab(); trackBy: trackByGroupId"
          [class.approved]="item.status === 'Approved'"
          [class.pending]="item.status === 'Pending'"
          [class.rejected]="item.status === 'Rejected'"
          [class.cancelled]="item.status === 'Cancelled'"
          (click)="openGroup(item.group.id, item.status === 'Approved' ? true : item.status === 'Rejected' ? false : null, item.status === 'Cancelled', item.scope)"
        >
          <div class="figma-card-top">
            <div class="figma-card-tags">
              <span class="type-pill">{{ item.group.payCode.name || 'Time Off' }}</span>
              <span
                class="state-pill"
                [class.approved]="item.status === 'Approved'"
                [class.pending]="item.status === 'Pending'"
                [class.rejected]="item.status === 'Rejected'"
                [class.cancelled]="item.status === 'Cancelled'"
              >
                {{ item.status }}
              </span>
            </div>

            <span class="status-date">{{ getRequestStatusDate(item.group, item.status) }}</span>
          </div>

          <div class="figma-person-row">
            <span class="figma-avatar">{{ getRequestInitials(item.group) }}</span>
            <span>
              <strong>{{ getRequestEmployeeName(item.group, item.scope) }}</strong>
              <small>{{ getRequestActorLine(item.group, item.scope) }}</small>
            </span>
          </div>

          <div class="figma-metric-grid">
            <div class="figma-metric">
              <span>DATES</span>
              <strong>{{ getRequestDateRange(item.group) }}</strong>
              <small>{{ getRequestDayCountLabel(item.group) }}</small>
            </div>

            <div class="figma-metric">
              <span>REQUESTED</span>
              <strong>{{ getRequestTotalHours(item.group) | number:'1.0-0' }}h</strong>
              <small>hours off</small>
            </div>

            <div class="figma-metric">
              <span>BALANCE</span>
              <strong>{{ getRequestBalanceAvailable(item.group) ?? 0 | number:'1.0-0' }}h</strong>
              <small>available</small>
            </div>
          </div>
        </button>
      </div>

      <ng-template #noMyRequests>
        <div class="figma-empty-card">No {{ activeTab | lowercase }} requests.</div>
      </ng-template>

    </section>

    <section class="figma-request-section">
      <div class="figma-section-header">
    <div class="figma-section-label">
      <span>OTHERS' REQUESTS</span>
      <span class="section-count">{{ getRequestTotalForActiveTab('all') }}</span>
    </div>

    <div class="figma-section-pager" *ngIf="getRequestPageInfoForActiveTab('all') as page">
      <button
        type="button"
        (click)="goToRequestPage(activeTab, 'all', page.currentPage - 1)"
        [disabled]="isBusy || page.currentPage <= 1">
        ←
      </button>

      <span>{{ page.currentPage }} / {{ page.totalPages }}</span>

      <button
        type="button"
        (click)="goToRequestPage(activeTab, 'all', page.currentPage + 1)"
        [disabled]="isBusy || page.currentPage >= page.totalPages">
        →
      </button>
    </div>
  </div>
      <div class="figma-request-grid" *ngIf="getOthersRequestsForActiveTab().length; else noOtherRequests">
        <button
          type="button"
          class="figma-status-card"
          *ngFor="let item of getOthersRequestsForActiveTab(); trackBy: trackByGroupId"
          [class.approved]="item.status === 'Approved'"
          [class.pending]="item.status === 'Pending'"
          [class.rejected]="item.status === 'Rejected'"
          [class.cancelled]="item.status === 'Cancelled'"
          (click)="openGroup(item.group.id, item.status === 'Approved' ? true : item.status === 'Rejected' ? false : null, item.status === 'Cancelled', item.scope)"
        >
          <div class="figma-card-top">
            <div class="figma-card-tags">
              <span class="type-pill">{{ item.group.payCode.name || 'Time Off' }}</span>
              <span
                class="state-pill"
                [class.approved]="item.status === 'Approved'"
                [class.pending]="item.status === 'Pending'"
                [class.rejected]="item.status === 'Rejected'"
                [class.cancelled]="item.status === 'Cancelled'"
              >
                {{ item.status }}
              </span>
            </div>

            <span class="status-date">{{ getRequestStatusDate(item.group, item.status) }}</span>
          </div>

          <div class="figma-person-row">
            <span class="figma-avatar">{{ getRequestInitials(item.group) }}</span>
            <span>
              <strong>{{ getRequestEmployeeName(item.group, item.scope) }}</strong>
              <small>{{ getRequestActorLine(item.group, item.scope) }}</small>
            </span>
          </div>

          <div class="figma-metric-grid">
            <div class="figma-metric">
              <span>DATES</span>
              <strong>{{ getRequestDateRange(item.group) }}</strong>
              <small>{{ getRequestDayCountLabel(item.group) }}</small>
            </div>

            <div class="figma-metric">
              <span>REQUESTED</span>
              <strong>{{ getRequestTotalHours(item.group) | number:'1.0-0' }}h</strong>
              <small>hours off</small>
            </div>

            <div class="figma-metric">
              <span>BALANCE</span>
              <strong>{{ getRequestBalanceAvailable(item.group) ?? 0 | number:'1.0-0' }}h</strong>
              <small>available</small>
            </div>
          </div>
        </button>
      </div>

      <ng-template #noOtherRequests>
        <div class="figma-empty-card">No {{ activeTab | lowercase }} requests from others.</div>
      </ng-template>
    </section>
  </main>

  <main *ngIf="activeTab !== 'Create' && viewMode === 'details'" class="figma-detail-page">
    <section class="figma-page-title">
      <h1>
        {{ getActiveTabTitle() }}
        <span
          class="heading-count"
          [class.approved]="activeTab === 'Approved'"
          [class.pending]="activeTab === 'Pending'"
          [class.rejected]="activeTab === 'Rejected'"
          [class.cancelled]="activeTab === 'Cancelled'"
        >
          {{ getActiveTabCount() }}
        </span>
      </h1>

      <p>{{ getActiveTabSubtitle() }}</p>
    </section>

    <button type="button" class="figma-back-btn" (click)="backToRequestList()">← Back to list</button>

    <ng-container *ngIf="editState">
      <section
        class="figma-detail-hero"
        [class.approved]="editState.status === 'Approved'"
        [class.pending]="editState.status === 'Pending'"
        [class.rejected]="editState.status === 'Rejected'"
        [class.cancelled]="editState.status === 'Cancelled'"
      >
        <div class="figma-detail-hero-top">
          <div class="figma-detail-person">
            <span class="figma-avatar large">
              {{ editRequestedForDisplayName.charAt(0) }}{{ editRequestedForDisplayName.split(' ')[1]?.charAt(0) || '' }}
            </span>

            <div>
              <div class="figma-detail-title-line">
                <h2>{{ editRequestedForDisplayName }}</h2>
                <span
                  class="state-pill"
                  [class.approved]="editState.status === 'Approved'"
                  [class.pending]="editState.status === 'Pending'"
                  [class.rejected]="editState.status === 'Rejected'"
                  [class.cancelled]="editState.status === 'Cancelled'"
                >
                  {{ editState.status }}
                </span>
                <span class="type-pill">{{ getEditPayCodeName() }}</span>
              </div>

              <p>{{ getEditSubmittedLine() }}</p>
            </div>
          </div>

          <div class="figma-detail-actions" *ngIf="canApproveReject">
            <button type="button" class="approve-action" (click)="approveOpenGroup()" [disabled]="isBusy">Approve</button>
            <button type="button" class="reject-action" (click)="rejectOpenGroup()" [disabled]="isBusy">Reject</button>
            <button type="button" class="cancel-action" (click)="cancelEntireGroup()" [disabled]="!canCancelOpenGroup">Cancel</button>
          </div>
        </div>

        <div class="figma-hero-metrics">
          <div class="figma-hero-metric">
            <span>HOURS REQUESTED</span>
            <strong>{{ getEditHoursRequested() | number:'1.0-0' }}h</strong>
            <small>total</small>
          </div>

          <div class="figma-hero-metric">
            <span>CURRENT BALANCE</span>
            <strong>{{ getEditBalanceImpact()?.currentBalance ?? 0 | number:'1.0-0' }}h</strong>
            <small>vacation hrs</small>
          </div>

          <div class="figma-hero-metric">
            <span>AFTER REQUEST</span>
            <strong>{{ getEditAfterRequestBalance() ?? 0 | number:'1.0-0' }}h</strong>
            <small>remaining</small>
          </div>

          <div class="figma-hero-metric">
            <span>DAYS OFF</span>
            <strong>{{ getEditDaysOffCount() }}</strong>
            <small>days</small>
          </div>
        </div>
      </section>

      <section class="figma-detail-card">
        <h3>REASON</h3>
        <p>{{ editState.reason || '—' }}</p>
      </section>

      <section class="figma-detail-card schedule">
        <div class="figma-detail-card-header">
          <h3>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <path d="M16 2v4" />
              <path d="M8 2v4" />
              <path d="M3 10h18" />
            </svg>
            SCHEDULE
          </h3>

          <button type="button" class="figma-add-link" *ngIf="canEditOpenGroup">+ Add Day</button>
        </div>

        <div class="figma-schedule-detail-list">
          <div class="figma-schedule-detail-row" *ngFor="let d of editState.days">
            <div class="figma-detail-date">
              <span class="blue-dot"></span>
              <div>
                <strong>{{ d.start.format('ddd, MMM D, YYYY') }}</strong>
                <small>{{ getEditDayStatusLabel(d) }}</small>
              </div>
            </div>

            <select
              [ngModel]="minutesFromMidnight(d.start)"
              (ngModelChange)="onEditStartMinutesChange(d, $event)"
              [disabled]="!canEditOpenGroup || d.isCancelled || !canEditExistingDay(d)"
            >
              <option *ngFor="let t of timeOptions" [ngValue]="t.minutes">{{ t.label }}</option>
            </select>

            <span class="time-separator">-</span>

            <select
              [ngModel]="minutesFromMidnight(d.end)"
              (ngModelChange)="onEditEndMinutesChange(d, $event)"
              [disabled]="!canEditOpenGroup || d.isCancelled || !canEditExistingDay(d)"
            >
              <option *ngFor="let t of getEndTimeOptionsAfter(minutesFromMidnight(d.start))" [ngValue]="t.minutes">
                {{ t.label }}
              </option>
            </select>

            <span class="figma-duration-mini">{{ getEditDayDuration(d) }}</span>

            <button type="button" class="figma-trash-btn" *ngIf="canEditOpenGroup" (click)="cancelExistingDay(d.id)">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M3 6h18" />
                <path d="M8 6V4h8v2" />
                <path d="M19 6l-1 14H6L5 6" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      <section class="figma-detail-card attachments">
        <div class="figma-detail-card-header">
          <h3>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.64 17.2a2 2 0 0 1-2.83-2.83l8.49-8.49" />
            </svg>
            ATTACHMENTS
          </h3>

          <label class="figma-add-link" *ngIf="canAddFilesToOpenGroup">
            + Add File
            <input type="file" hidden multiple (change)="onAttachmentFilesSelected($event)" />
          </label>
        </div>

        <div class="figma-attachments-empty" *ngIf="!editState.files.length && !selectedAttachmentFiles.length">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.64 17.2a2 2 0 0 1-2.83-2.83l8.49-8.49" />
          </svg>
          <p>No attachments</p>
        </div>

        <app-request-file-preview *ngIf="editState.files.length" [files]="editState.files"></app-request-file-preview>

        <div class="row-chips" *ngIf="selectedAttachmentFiles.length">
          <span class="chip" *ngFor="let file of selectedAttachmentFiles; let i = index">
            {{ file.name }}
            <button type="button" class="ghost-btn small" (click)="removeAttachmentFile(i)">Remove</button>
          </span>

          <button type="button" class="primary-btn small" (click)="uploadFilesForOpenGroup()" [disabled]="isBusy">
            Upload
          </button>
        </div>
      </section>
    </ng-container>
  </main>

  <div class="confirm-backdrop" *ngIf="confirmOpen" (click)="onConfirmCancel()">
    <div class="confirm-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <div class="confirm-header">
        <h3 class="confirm-title">{{ confirmTitle }}</h3>

        <button type="button" class="ghost-btn small" (click)="onConfirmCancel()" aria-label="Close">
          Close
        </button>
      </div>

      <div class="confirm-body">
        <div class="confirm-message">{{ confirmMessage }}</div>
      </div>

      <div class="confirm-actions">
        <button type="button" class="ghost-btn" (click)="onConfirmCancel()">
          {{ confirmCancelText }}
        </button>

        <button
          type="button"
          [class.primary-btn]="confirmKind === 'default'"
          [class.danger-btn]="confirmKind === 'danger'"
          (click)="onConfirmOk()"
        >
          {{ confirmOkText }}
        </button>
      </div>
    </div>
  </div>
</div>